var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',_vm._g(_vm._b({ref:"buttonRef",class:[ _vm.color, _vm.classes ],attrs:{"type":_vm.type,"disabled":_vm.disabled || _vm.isLoading},on:{"blur":_vm.handleBlur,"focus":_vm.handleFocus,"click":_vm.onClick}},'button',_vm.$attrs,false),_vm.listeners),[(_vm.buttonIcon)?_c('font-awesome-icon',{class:{
      icon: _vm.icon,
      'min-width': true,
      'icon-spacer': _vm.iconSpacer,
      'centered-icon': _vm.isLoaderWithoutIcon,
    },attrs:{"pulse":_vm.isLoading,"icon":_vm.buttonIcon}}):_vm._e(),_c('span',{class:{ 'hide-text': _vm.isLoaderWithoutIcon }},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }